import React from 'react'
import CollectionOfLinkBoxes from './CollectionOfLinkBoxes'

function WebsitesArea() {
    const linkCollectionName = "Websites";
    const linkCollectionDescription = "Here are some websites I have made:"
    const myWebsites = [{
        title: "Mooramo",
        description: "An educational website I am developing. Note: the current live version is quite old - new version coming soon!",
        url: "http://www.mooramo.com/"
    },{
        title: "St Peter's Covid Mutual Aid",
        description: "A webpage I created to help people in my local area find mutual aid groups during the covid pandemic.",
        url: "http://stpeterscovidmutualaid.com/"
    }];
    return (
        <div>
            <CollectionOfLinkBoxes linkCollectionDescription={linkCollectionDescription} linkCollectionName={linkCollectionName} links={myWebsites}></CollectionOfLinkBoxes>
        </div>
    )
}

export default WebsitesArea
